import { redirectSsoProfessionalToAuthorize } from "@Front/integrations/oauth-default/ssoOauthRedirect";
import { isPublicSiteEnsoLine } from "@Front/Utils/publicSiteBranding";
import useStepEmailController from "./hooks/useStepEmailController";
import { usePublicIntegrationFlags } from "./hooks/usePublicIntegrationFlags";
import { useStepEmailSiteTexts, type StepEmailOuterProps } from "./hooks/useStepEmailSiteTexts";
import StepEmailPanelsContent from "./components/StepEmailPanelsContent";
import { computeStepEmailSsoUiFlags } from "./stepEmailSsoUiVisibility";

export default function StepEmailPanels(props: StepEmailOuterProps): React.JSX.Element {
	const { onSubmit, validationErrors } = props;
	const controller = useStepEmailController();
	const siteTexts = useStepEmailSiteTexts();
	const { ready, flags, sso_oauth_client_id, __DATA_SSO_OAUTH_LOGIN_PRESETS__ } = usePublicIntegrationFlags();
	const isEnsoPublicLine = isPublicSiteEnsoLine();
	const { showSsoOauthLoginPresetPicker, showSsoProfessionalBlock } = computeStepEmailSsoUiFlags({
		ready,
		flags,
		sso_oauth_client_id,
		__DATA_SSO_OAUTH_LOGIN_PRESETS__,
		isEnsoPublicLine,
	});

	return (
		<StepEmailPanelsContent
			siteTexts={siteTexts}
			showSsoProfessionalBlock={showSsoProfessionalBlock}
			showSsoOauthLoginPresetPicker={showSsoOauthLoginPresetPicker}
			ssoOauthLoginPresets={__DATA_SSO_OAUTH_LOGIN_PRESETS__ ?? []}
			onSsoProfessionalClick={() => void redirectSsoProfessionalToAuthorize(undefined, sso_oauth_client_id)}
			onSsoOauthLoginPresetEmail={(email) => void redirectSsoProfessionalToAuthorize(email, sso_oauth_client_id)}
			onSubmit={onSubmit}
			validationErrors={validationErrors}
			prefilledEmail={controller.prefilledEmail}
		/>
	);
}
